import React, { useState } from 'react';
import Spinner from '../Components/Spiner/Spinner'; // Asegúrate de ajustar la ruta
import Topbar from '../Components/Topbar/TopBar';
import Navbar from '../Components/Navbar/Navbar';
import Carrusel from '../Components/Carrusel/Carrusel'; // Ajusta la ruta según tu estructura
import BannerStart from '../Components/BannerStart/BannerStart';
import About from '../Components/About/About';
import Appointment from '../Components/Appointments/Appointments';
import ServiceStart from '../Components/ServiceStart/ServiceStart';
import Offer from '../Components/Offers/Offer';
import Pricing from '../Components/Pricing/Pricing';
//import Testimonial from '../Components/Testimonial/Testimonial';
import Team from '../Components/Team/Team';
import Footer from '../Components/Footer/Footer';

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Simula la carga con un temporizador
  React.useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Topbar />
      <Navbar />
      <Spinner isLoading={isLoading} />
      {!isLoading && (
        <>
          <Carrusel />         
        </>
      )}
      <BannerStart />
      <About />
      <Appointment />
      <Team />
      <ServiceStart />
      <Offer />
      <Pricing />
      <Footer />
    </div>
  );
};

export default Home;
